// extracted by mini-css-extract-plugin
export default {"fieldContainer":"ProductImageUpload_fieldContainer__Do6W1"};